export const validationObject = {
	formSelector: "form",
	inputSelector: "form__input",
	submitButtonSelector: "form__button_type_save",
	inactiveButtonClass: "button_inactive",
	inputErrorClass: "form__input_error",
	errorClass: "form__input-text-error_active",
};

export const apiObject = {
	baseUrl: "https://api.around.rokux9.com",
	headers: {
		"Content-Type": "application/json",
	},
};
